/* unplugin-vue-components disabled */import script from "./ModuleCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModuleCard.vue?vue&type=script&lang=ts&setup=true"

import "./ModuleCard.vue?vue&type=style&index=0&id=50f7d750&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50f7d750"]])

export default __exports__